import multipleHvns from './multi-hvns';

export default function (server) {
  multipleHvns(server, { hasMultiRegion: true });
}
